const T_PREFIX = "cabinet";

export const cabinetTrns = {
  ownerCabinetTitle: `${T_PREFIX}.owner.title`,
  agentCabinetTitle: `${T_PREFIX}.agent.title`,
};

export const cabinetNavigationSidebarTrns = {
  myInquiries: `${T_PREFIX}.navigation-sidebar.my-inquiries`,
  myClones: `${T_PREFIX}.navigation-sidebar.my-clones`,
  watchlist: `${T_PREFIX}.navigation-sidebar.watchlist`,
  favorites: `${T_PREFIX}.navigation-sidebar.favorites`,
  settings: `${T_PREFIX}.navigation-sidebar.settings`,
  deals: `${T_PREFIX}.navigation-sidebar.deals`,
};
